import React, { useState, useMemo } from 'react';

import { FormattedMessage, useIntl } from 'react-intl';

import { ReactTable } from '@nhl/nhl-breakaway-ui';
import useInterval from '@use-it/interval';

import { commonMessages } from '~/utility/commonMessages';
import { ReactTableContainer } from '~/views/components/statsTable/styles';

import { columnDefs } from './columnDefinitions';

import { Position } from './styles';

const getPrimaryJerseyColor = (team, season) =>
    team.teamColorways.find(
        (colorway) => colorway.startSeason <= season && colorway.endSeason >= season && colorway.side === 'home',
    )?.primaryJerseyColor || '#333';

// speed ceiling will be max speed - this value, which is between .5 and 2 mph (or .7333 and 2.933 feet per second -
// done this way for easier conversion to kph)
const getNewSpeedCeilingRandomizer = () => Math.random() * (2.933 - 0.7333) + 0.7333;

const TrackingDataTable = ({
    pptData,
    team,
    game,
    speedConversionFactor,
    distanceConversionFactor,
    totalDistanceConversionFactor,
    conversionFactorKey,
}) => {
    const intl = useIntl();
    const [speedCeilingRandomizer, setSpeedCeilingRandomizer] = useState(getNewSpeedCeilingRandomizer());

    // update speed ceiling ever 30 seconds
    useInterval(() => setSpeedCeilingRandomizer(getNewSpeedCeilingRandomizer()), 30000);

    const forwards = pptData.filter((player) => player.Entity.Position === 'F');
    const defense = pptData.filter((player) => player.Entity.Position === 'D');

    const columns = useMemo(
        () =>
            columnDefs(
                intl,
                speedConversionFactor,
                distanceConversionFactor,
                totalDistanceConversionFactor,
                conversionFactorKey,
                speedCeilingRandomizer,
            ),
        [
            intl,
            speedConversionFactor,
            distanceConversionFactor,
            totalDistanceConversionFactor,
            conversionFactorKey,
            speedCeilingRandomizer,
        ],
    );

    return (
        <div className="tracking-data-table">
            <div className="team-header" style={{ backgroundColor: getPrimaryJerseyColor(team, game.season) }}>
                {team.fullName}
            </div>
            <ReactTableContainer>
                <ReactTable data={forwards} columns={columns} />
            </ReactTableContainer>

            <Position>
                <FormattedMessage {...commonMessages.positions.D} />
            </Position>
            <ReactTableContainer>
                <ReactTable data={defense} columns={columns} />
            </ReactTableContainer>
        </div>
    );
};

export default TrackingDataTable;
